import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import axios from "axios";
import Header from "../../components/Header/Header";
import GenerPanel from "../../components/GenrePanel/GenrePanel";
import { url } from "../../Constant";
import {
  LandingPageContainer,
  LandingPageHeaderContainer,
  LandingPageVideoConatiner,
} from "./LandingPageStyling";
import DashBoard from "../../components/DashBoard/DashBoard";

const LandingPage = () => {
  const [videoCard, setVideoCard] = useState([]);

  const [Genre, setGenre] = useState(["All"]);
  const [sort, setSort] = useState();
  const [searchText, setSearchText] = useState("");
  const [debounceTimeOut, setDebounceTimeOut] = useState(0);

  const [generList] = useState([
    { name: "All", id: "AllGenre", value: "All" },
    { name: "Education", id: "Education", value: "Education" },
    { name: "Sports", id: "Sports", value: "Sports" },
    { name: "Comedy", id: "Comedy", value: "Comedy" },
    { name: "Lifestyle", id: "Lifestyle", value: "Lifestyle" },
  ]);
  const [ageGroupList] = useState([
    { name: "All age Group", id: "Anyone", value: "Anyone" },
    { name: "7+", id: "7+", value: "7+" },
    { name: "12+", id: "12+", value: "12+" },
    { name: "16+", id: "16+", value: "16+" },
    { name: "18+", id: "18+", value: "18+" },
  ]);

  const handleSortChange = (e) => {
    setSort(e.target.value);
  };

  const handleClick = (buttonName) => {
    if (buttonName === "All") {
      setGenre(["All"]);
    } else if (Genre.includes(buttonName)) {
      setGenre(Genre.filter((ele) => ele !== buttonName));
    } else {
      setGenre([...Genre.filter((ele) => ele !== "All"), buttonName]);
    }
  };

  const FetchVideoFromURL = async () => {
    try {
      const urlData = await axios(
        `${url}/v1/videos?genres=${Genre.length <= 0 ? "All" : Genre.join()}`
      );
      console.log(urlData);
      setVideoCard([...urlData.data.videos]);
    } catch (error) {
      return null;
    }
  };

  const fetchSortByFromURL = async () => {
    try {
      // let sortBy = "${url}/v1/videos?sortBy=";
      let urlData = "";
      if (sort === "releaseDate") {
        urlData = await axios(`${url}/v1/videos?sortBy=releaseDate`);
        setVideoCard([...urlData.data.videos]);
      } else {
        urlData = await axios(`${url}/v1/videos?sortBy=viewCount`);
        setVideoCard([...urlData.data.videos]);
      }
      // console.log(sortBy);
    } catch (error) {
      return null;
    }
  };

  const debounceSearch = (event) => {
    setSearchText(event);
    if (debounceTimeOut) {
      clearTimeout(debounceTimeOut);
    }
    let timerid = setTimeout(() => {
      performSearch(searchText);
    }, 500)
    setDebounceTimeOut(timerid);
  };

  const performSearch = async (text) => {
    try {
      const searchUrl = `${url}/v1/videos?title=${text}`;
      const urlResponse = await axios.get(searchUrl);
      setVideoCard([...urlResponse.data.videos]);
     }
    catch (error) {
      return null;
    }
}

  useEffect(() => {
    FetchVideoFromURL();
  }, [Genre]);

  useEffect(() => {
    fetchSortByFromURL()
  }, [sort])

  return (
    <>
      <div style={LandingPageContainer}>
        <div style={LandingPageHeaderContainer}>
          <Header searchText={searchText} debounceSearch={debounceSearch} />
          <GenerPanel
            Genre={Genre}
            sort={sort}
            generList={generList}
            ageGroupList={ageGroupList}
            handleClick={handleClick}
            handleSortChange={handleSortChange}
          />
        </div>
        <div>
          <Grid
            container
            spacing={2}
            item
            justifyContent="center"
            alignItems="center"
            style={LandingPageVideoConatiner}
          >
            {videoCard.map((videoItem) => (
              <Grid item key={videoItem._id}>
                <DashBoard
                  id={videoItem._id}
                  image={videoItem.previewImage}
                  title={videoItem.title}
                  releaseDate={videoItem.releaseDate}
                  videoLink={videoItem.videoLink}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
